import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Backdrop from '@mui/material/Backdrop'
import Portal from '@mui/base/Portal'
import {Search, Close} from '@mui/icons-material'
import {injectIntl} from 'react-intl'
import {fetchUsers, updateUser, deleteUser, setOwner} from 'modules/applications/actions'
import {fetchModules} from 'modules/modules/actions'
import UserSettings from 'components/UserSettings'
import permissions from 'utils/enums/permissions'

const SearchInput = styled.div`
    background-color: rgba(160, 183, 190, .24);
    border-radius: 2px;
    height: 40px;
    width: 320px;
    align-items: center;
    display: flex;
    transition: background-color .3s cubic-bezier(.55, 0, .1, 1);

    :focus-within {
        background-color: rgba(160, 183, 190, .35);
    }

    input {
        width: 100%;
        height: 100%;
        padding: 0;

        ::placeholder {
            font-style: italic;
        }
    }
`

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between
`

const List = styled.div`
    margin-top: 30px;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

class Users extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            pattern: '',
            user: null
        }

    }

    componentDidMount() {
        this.props.fetchUsers()
        this.props.fetchModules()
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleClear = (e) => {
        this.setState({
            pattern: ''
        })
    }

    handleClose = (e) => {
        this.setState({
            user: null
        }, () => {
            const body = document.getElementById('wrapper')
            body.style.overflow = ''
        })
    }

    handleCreate = () => {
        const user = {
            id: 0,
            disabledModules: [],
            disabledTables: [],
            name: '',
            permissions: permissions.Read | permissions.Write | permissions.Delete
        }

        this.setState({
            user
        }, () => {
            const list = document.getElementsByName('name')
            const el = list[0]
            el.focus()
            el.scrollIntoView()
            const body = document.getElementById('wrapper')
            body.style.overflow = 'hidden'
        })
    }

    handleSave = () => {
        const user = {...this.state.user}

        if ((user.permissions & permissions.Designer) === permissions.Designer) {
            user.disabledTables = []
            user.disabledModules = []
        }

        this.props.updateUser(user)
        this.handleClose()
    }

    onEditClick = (id) => {
        this.setState({
            user: this.props.users.find(item => item.id === id)
        }, () => {
            const el = document.querySelector(`[data-user='${id}']`)
            el.scrollIntoViewIfNeeded()
            const body = document.getElementById('wrapper')
            body.style.overflow = 'hidden'
        })
    }

    handleUpdate = (value, key) => {
        const user = {...this.state.user}

        if (key === 'name') {
            user.name = value
        } else if (key === 'permissions') {
            user.permissions = value
        } else if (key === 'table') {
            user.disabledTables = [...value]
        } else if (key === 'module') {
            user.disabledModules = [...value]
        }

        this.setState({
            user
        })
    }

    render() {
        const {intl} = this.props

        return (
            <div>
                <Row>
                    <SearchInput>
                        <Search sx={{fontSize: 20, margin: '0 12px', cursor: 'pointer'}} />
                        <input
                            value={this.state.pattern}
                            placeholder={intl.formatMessage({id: "table.search"})}
                            onChange={this.handleChange}
                            name='pattern'
                        />
                        {this.state.pattern &&
                            <Close onClick={this.handleClear}
								sx={{
									fontSize: 20,
									margin: '0 12px',
									cursor: 'pointer'
								}}
							/>
                        }
                    </SearchInput>
                    <Button
                        onClick={this.handleCreate}
                        style={{background: '#4cae4c', color: '#FFF', marginLeft: '20px'}}
                    >
                        {intl.formatMessage({id: "settings.add_user"})}
                    </Button>
                </Row>
                <List>
                    {!!this.props.users.length && this.props.users.filter(user =>
                        user.name.indexOf(this.state.pattern) !== -1).map((item, index) =>
                        <UserSettings key={item.id}
                            user={this.state.user && item.id === this.state.user.id ? this.state.user : item}
                            edit={this.state.user && item.id === this.state.user.id}
                            handleEdit={this.onEditClick}
                            handleClose={this.handleClose}
                            handleChange={this.handleUpdate}
                            handleSave={this.handleSave}
                            handleDelete={this.props.deleteUser}
							handleSet={this.props.setOwner}
                            entities={this.props.entities}
                            modules={this.props.modules}
                        />
                    )}
                    {this.state.user && !this.state.user.id &&
                        <UserSettings
                            error={this.props.users.length && !!this.props.users.find(item => item.name === this.state.user.name)}
                            user={this.state.user}
                            edit={true}
                            handleClose={this.handleClose}
                            handleChange={this.handleUpdate}
                            handleSave={this.handleSave}
                            entities={this.props.entities}
                            modules={this.props.modules}
                        />
                    }
                    {!this.props.users.filter(user =>
                        user.name.indexOf(this.state.pattern) !== -1).length && !this.state.user &&
                        <Typography variant="subtitle1">{intl.formatMessage({id: "settings.users_not_found"})}</Typography>
                    }
                </List>
                {!!this.state.user &&
                    <Portal>
                        <Backdrop open={!!this.state.user} onClick={this.handleClose} sx={{zIndex: 1300}} />
                    </Portal>
                }
            </div>
        )
    }
}

const mapStateToProps = ({applications, modules, entities}) => ({
    users: applications.users,
    modules: modules.modules,
    entities: entities.entities
})

export default connect(mapStateToProps, {
    fetchUsers,
    updateUser,
    deleteUser,
    fetchModules,
	setOwner
})(injectIntl(Users))
